// Shared "Living Cast" picker helpers — AI character slug + thumbnail path.
//
// Mirrors the implementation in src/components/LivingCast.tsx so the
// dashboard renders the same character for a given donor handle.

export const AI_CHARS = [
  "aria",
  "boris",
  "cosma",
  "drako",
  "eevy",
  "fynn",
  "gala",
] as const;

export type AiCharSlug = (typeof AI_CHARS)[number];

// FNV-1a 32-bit, byte-for-byte identical to LivingCast.
function fnv1a(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

export function normHandle(handle: string | null | undefined): string {
  const raw = (handle ?? "").trim().toLowerCase();
  return raw.replace(/^@/, "") || "anon";
}

export function pickAiChar(handle: string | null | undefined): AiCharSlug {
  return AI_CHARS[fnv1a(normHandle(handle)) % AI_CHARS.length];
}

export function aiCharImage(handle: string | null | undefined): string {
  return `/overlay-demo/ai-chars/${pickAiChar(handle)}.png`;
}
